import {
    DIVISION_LIST_PARTNER_SUCCESS,
    DIVISION_LIST_PARTNER_FAILED,
    RESET_DIVISION_LIST_PARTNER,
    LOADING_DIVISION_LIST_PARTNER,
    NETWORK_ERROR_DIVISION_LIST_PARTNER
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetdivisionListPartner = () => {
    return { type: RESET_DIVISION_LIST_PARTNER };
};

const divisionListPartner = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DIVISION_LIST_PARTNER });
    await partnerServices
        .post("divisionListPartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            console.log("dadadad",res)
            switch (res.data.status) {
                
                case "Success":
                    dispatch({ type: DIVISION_LIST_PARTNER_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: DIVISION_LIST_PARTNER_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DIVISION_LIST_PARTNER,
                payload: err
            });
        });
};

export { resetdivisionListPartner, divisionListPartner };
